import ReactGA from 'react-ga4';

export const trackCheckInEnterEmail = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_enter_email',
  });
};

export const trackCheckInThirdPartyAuthSuccess = (thirdParty: string) => {
  ReactGA.event({
    category: 'Attendee',
    action: `check_in_${thirdParty}_auth_success`,
  });
};

export const trackCheckInThirdPartyAuthError = (
  thirdParty: string,
  errMsg: string,
) => {
  ReactGA.event({
    category: 'Attendee',
    action: `check_in_${thirdParty}_auth_error`,
    label: errMsg,
  });
};

export const trackCheckInPersonSuccess = (isNew: boolean) => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_person_success',
    label: `${isNew ? 'New' : 'Existing'} attendee`,
  });
};

export const trackCheckInPersonError = (errMsg: string) => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_person_error',
    label: errMsg,
  });
};

export const trackCheckInUpdatePersonSuccess = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_update_person_success',
  });
};

export const trackCheckInUpdatePersonError = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_update_person_error',
  });
};

export const trackCheckInUploadFileSuccess = (type: string) => {
  ReactGA.event({
    category: 'Attendee',
    action: `check_in_upload_${type}_success`,
  });
};

export const trackCheckInUploadFileError = (type: string, fileName: string) => {
  ReactGA.event({
    category: 'Attendee',
    action: `check_in_upload_${type}_error`,
    label: fileName,
  });
};

export const trackCheckInBatchUploadVideoSuccess = (count: number) => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_batch_upload_video_success',
    value: count,
  });
};

export const trackCheckInUGCDetailsClickYes = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_ugc_details_click_yes',
  });
};

export const trackCheckInUGCDetailsClickNo = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_ugc_details_click_no',
  });
};

export const trackCheckInMAEmailMatch = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_ma_email_match',
  });
};

export const trackCheckInMAEmailNoMatch = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_ma_email_no_match',
  });
};

export const trackCheckInMAEmailGenerated = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_ma_email_generated',
  });
};

export const trackCheckInClickHelp = () => {
  ReactGA.event({
    category: 'Attendee',
    action: 'check_in_click_help',
  });
};
